<template>
  <v-layout row wrap id="transaction_area">
    <v-flex sm12 md3 lg3 class="vertLine" v-if="orderType !== 1">
      <p class="body-2 font-weight-bold text-red">Danh sách mã đơn hàng</p>
      <v-list>
        <v-list-item-group v-model="selectedOrderCode" color="primary" mandatory>
          <v-list-item v-for="(item,index) in orderCodes" :key="item.ID">
            <v-list-item-content>
              <v-text-field v-model="item.OrderCodeCN" readonly class="no-boder"></v-text-field>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn icon @click="removeOrderCode(index)" v-if="(orderEditRole & 8) && !disabled && orderCodeEditable && !locked">
                <v-icon>fa-trash-alt</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      <v-layout pl-5 pr-7 row wrap align-center v-if="(orderEditRole & 8) && !disabled && !locked && !paymentRole">
        <v-text-field
          label="Mã đơn hàng"
          v-model="newOrderCode.OrderCodeCN"
          class="input-group--focused mx-1 px-0 pt-0"
          @keyup.enter="addOrderCode()"
          :disabled="!(orderEditRole & 8) || disabled || !orderCodeEditable || locked"
        ></v-text-field>
        <v-btn icon @click="addOrderCode()" :disabled="!(orderEditRole & 8) || disabled || locked ||  !orderCodeEditable || newOrderCode.OrderCodeCN == ''">
          <v-icon color="#dc3545">far fa-plus-square</v-icon>
        </v-btn>
      </v-layout>
    </v-flex>
    <v-flex v-bind:class="{ 'sm12 md9 lg9': orderType !== 1, 'sm12 md12 lg12': orderType === 1}">
      <p class="body-2 font-weight-bold text-red">Danh sách mã vận đơn</p>
      <v-layout pl-2 row wrap align-center v-for="(item,index) in selectedTransCodes" :key="index">
        <v-text-field
          label="Mã vận đơn"
          v-model="item.TransactionCode"
          class="input-group--focused mx-1 px-0"
          @change="editTransCode(item)"
          :readonly="true"
        ></v-text-field>
        <h-currency-input
          label="Cân nặng"
          :decimal="2" 
          v-model="item.Weight"
          class="trans-weight input-group--focused mx-1 px-0"
          @press_enter="editTransCode(item)"
          @on_blur="editTransCode(item)"
          :disabled="((!(orderEditRole & 8) || disabled || checkPackageStatus(item.Status) || !weightEditable) && !adminRole) || locked"
        ></h-currency-input>
        <h-currency-input
          label="Dài (cm)"
          :decimal="1"
          v-model="item.Length"
          @press_enter="editTransCode(item)"
          @on_blur="editTransCode(item)"
          class="trans-weight input-group--focused mx-1 px-0"
          :disabled="((!(orderEditRole & 8) || disabled || checkPackageStatus(item.Status) || !weightEditable) && !adminRole) || locked"
        ></h-currency-input>
        <h-currency-input
          label="Rộng (cm)"
          :decimal="1"
          v-model="item.Width"
          @press_enter="editTransCode(item)"
          @on_blur="editTransCode(item)"
          class="trans-weight input-group--focused mx-1 px-0"
          :disabled="((!(orderEditRole & 8) || disabled || checkPackageStatus(item.Status) || !weightEditable) && !adminRole) || locked"
        ></h-currency-input>
        <h-currency-input
          label="Cao (cm)"
          :decimal="1"
          v-model="item.Height"
          @press_enter="editTransCode(item)"
          @on_blur="editTransCode(item)"
          class="trans-weight input-group--focused mx-1 px-0"
          :disabled="((!(orderEditRole & 8) || disabled || checkPackageStatus(item.Status) || !weightEditable) && !adminRole) || locked"
        ></h-currency-input>
        <h-currency-input
          label="Thể tích"
          :decimal="3"
          v-model="item.Volume"
          class="trans-weight input-group--focused mx-1 px-0"
          readonly
        ></h-currency-input>
        <h-currency-input
          label="Cân quy đổi"
          :decimal="2"
          v-model="item.WeightByVolume"
          class="trans-weight input-group--focused mx-1 px-0"
          readonly
        ></h-currency-input>
        <v-select
          class="trans-status"
          label="Trạng thái"
          :items="transStatus"
          v-model="item.Status"
          item-disabled="disabled"
          item-value="value"
          item-text="name"
          @change="editTransCode(item)"
          :disabled="true"
        ></v-select>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" @click="printTransaction(item.ID, item.PackageType)">
              <v-icon color="red darken-2">fa-print</v-icon>
            </v-btn>
          </template>
          <span>In tem</span>
        </v-tooltip>
        <v-btn icon @click="removeTransCode(index)" :disabled="((!(orderEditRole & 8) || disabled || !tranCodeEditable || checkPackageStatus(item.Status)) && !adminRole) || locked">
          <v-icon>fa-trash-alt</v-icon>
        </v-btn>
        <v-flex lg12 md12 sm12 pt-0 mt-0>
          <v-layout row wrap>
            <v-flex lg2 md2 sm2>
              <h-currency-input
                label="Phí ship"
                :decimal="2"
                v-model="item.FeeShip"
                @press_enter="editTransCode(item)"
                @on_blur="editTransCode(item)"
                class="input-group--focused"
                :disabled="((!(orderEditRole & 8) || disabled || checkPackageStatus(item.Status) || !weightEditable) && !adminRole) || locked"
              ></h-currency-input>
            </v-flex>
            <v-flex lg2 md2 sm2>
              <v-select label="Loại hàng" :items="product_types" v-model="item.ProductType" item-text="Name" item-value="ID" item-disabled="IsHidden" :disabled="((disabled || checkPackageStatus(item.Status)) && !adminRole) || locked" @change="editTransCode(item)"></v-select>
            </v-flex>
            <v-flex lg2 md2 sm2>
              <v-select label="Tính theo" :items="priceTypes" v-model="item.PriceType" item-text="name" item-value="value" clearable :disabled="((disabled || checkPackageStatus(item.Status)) && !adminRole) || locked" @change="editTransCode(item)"></v-select>
            </v-flex>
            <v-flex lg3 md3 sm3>
              <h-currency-input label="Đơn giá" :decimal="0" v-model="item.FeeWeight" class="input-group--focused" :disabled="((disabled || checkPackageStatus(item.Status)) && !adminRole && !paymentRole) || locked" @press_enter="editTransCode(item)" @on_blur="editTransCode(item)"></h-currency-input>
            </v-flex>
            <v-flex lg3 md3 sm3>
              <h-currency-input label="Thành tiền" :decimal="0" v-model="item.TotalFeeWeight" class="input-group--focused" readonly></h-currency-input>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex lg12 md12 sm12 pt-0 mt-0>
          <v-layout row wrap>
            <v-flex lg4 sm4>
              <v-text-field label="Tên hàng hoá" v-model="item.ProductName" class="input-group--focused"  :disabled="((disabled || checkPackageStatus(item.Status)) && !adminRole && !paymentRole) || locked" @change="editTransCode(item)"></v-text-field>
            </v-flex>
            <v-flex lg3 sm3>
              <h-currency-input label="Giá trị (¥)" :decimal="1" v-model="item.ProductAmount" class="input-group--focused" :disabled="((disabled || checkPackageStatus(item.Status)) && !adminRole && !paymentRole) || locked" @press_enter="editTransCode(item)" @on_blur="editTransCode(item)"></h-currency-input>
            </v-flex>
            <v-flex lg3 sm3>
              <h-currency-input label="Số kiện" :decimal="0" v-model="item.NumberOfPack" class="input-group--focused" :disabled="((disabled || checkPackageStatus(item.Status)) && !adminRole && !paymentRole) || locked" @press_enter="editTransCode(item)" @on_blur="editTransCode(item)"></h-currency-input>
            </v-flex>
            <v-flex lg2 sm2>
              <h-currency-input label="Số sản phẩm" :decimal="0" v-model="item.ProductNumber" class="input-group--focused" :disabled="((disabled || checkPackageStatus(item.Status)) && !adminRole && !paymentRole) || locked" @press_enter="editTransCode(item)" @on_blur="editTransCode(item)"></h-currency-input>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex lg12 md12 sm12 pt-0 mt-0>
          <v-layout row wrap>
            <a v-if="item.ProductImage" target="_blank" :href="item.ProductImage">
              <img v-if="item.ProductImage" style="max-width: 96px;max-height: 96px;" v-bind:src="item.ProductImage" ref="imageFile"/>
            </a>
            <v-textarea class="pa-2" v-model="item.OrderNote" background-color="#fefefe" dense rows="1" outlined label="Ghi chú" @change="editTransCode(item)"></v-textarea>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout pl-2 row wrap align-center v-if="(orderEditRole & 8) && !disabled && !locked && (orderType == 1 || selectedOrderCode != -1) && !(paymentRole && orderType != 1)">
        <v-text-field
          label="Mã vận đơn"
          v-model="newOrderTrans.TransactionCode"
          class="input-group--focused mx-1 px-0"
          :disabled="!(orderEditRole & 8) || disabled || locked || !tranCodeEditable"
          @keyup.enter="addTransCode()"
        ></v-text-field>
        <!-- <v-text-field
          label="Cân nặng"
          v-model="newOrderTrans.Weight"
          class="trans-weight input-group--focused mx-1 px-0"
          :disabled="!(orderEditRole & 8) || disabled || locked || !tranCodeEditable || !weightEditable"
        ></v-text-field>
        <v-select
          class="trans-status mr-3"
          label="Trạng thái"
          :items="transStatus"
          v-model="newOrderTrans.Status"
          item-disabled="disabled"
          item-value="value"
          item-text="name"
          :disabled="true"
        ></v-select> -->
        <v-btn icon @click="addTransCode()" class="ml-5" :disabled="!(orderEditRole & 8) || disabled || locked || !tranCodeEditable || newOrderTrans.TransactionCode == ''">
          <v-icon color="#dc3545">far fa-plus-square</v-icon>
        </v-btn>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import configs from "@/configs";
import _ from "lodash";
import { mapState } from "vuex";
import { print_transaction_v2, request_detail } from "@/commons/hpod";
import Vue from 'vue';

export default {
  name: "order-transaction",
  filters: {
    transLink: function(value, siteName, orderId, tmallid) {
      switch (siteName) {
        case "TAOBAO":
          // return `https://tradearchive.taobao.com/trade/detail/trade_item_detail.htm?bizOrderId=${value}&donhangchitietid=${orderId}`;
        case "TMALL":
          return `https://detail.i56.taobao.com/trace/trace_detail.htm?tId=${value}&userId=${tmallid}`;
        case "1688":
          return `https://trade.1688.com/order/new_step_order_detail.htm?orderId=${value}&donhangchitietid=${orderId}#logisticsTabTitle`;
        default:
          return `https://tradearchive.taobao.com/trade/detail/trade_item_detail.htm?bizOrderId=${value}&donhangchitietid=${orderId}`;
      }
    }
  },
  props: {
    orderStatus: {
      type: Number,
      default: null
    },
    orderType: {
      type: Number,
      default: 0
    },
    siteName: {
      type: String,
      default: "TAOBAO"
    },
    orderId: {
      type: Number,
      default: 0
    },
    customerName: {
      type: String,
      default: ""
    },
    customerID: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    locked: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      transStatus: configs.PACKAGE_STATUS,
      priceTypes: configs.PRICE_TYPES,
      showModalColumns: false,
      selectedOrderCode: -1,
      selectedTransCodes: [],
      newOrderCode: {
        OrderID: this.orderId,
        OrderCodeCN: "",
        CreatedBy: this.$store.state.authentication.user.username
      },
      newOrderTrans: {
        OrderID: this.orderId,
        Username: this.customerName,
        UID: this.customerID,
        PackageType: this.orderType,
        TransactionView: 'order_detail',
        TransactionCode: "",
        Weight: 0.0,
        WeightByVolume: 0.0,
        Status: configs.PACKAGE_STATUS_ENUM.DANG_DI_CHUYEN,
        CreatedBy: this.$store.state.authentication.user.username
      }
    };
  },
  watch: {
    orderCodes() {
        this.selectedOrderCode = (this.selectedOrderCode == -1 || this.selectedOrderCode >= this.orderCodes.length) ? this.orderCodes.length - 1 : this.selectedOrderCode;
    },
    transCodes() {
        this.reloadSelectedTransCodes();
    },
    selectedOrderCode() {
        this.reloadSelectedTransCodes();
    }
  },
  methods: {
    reloadSelectedTransCodes() {
        if(this.orderType === 1) {
            this.selectedTransCodes = this.transCodes;
        }
        else if(this.selectedOrderCode > -1 && this.orderCodes.length > 0){
            this.selectedTransCodes = _.filter(this.transCodes, {'OrderCodeID': this.orderCodes[this.selectedOrderCode].ID});
        }
        else {
            this.selectedTransCodes = [];
        }
    },
    removeOrderCode(index) {
      const item = this.orderCodes[index];
      this.$store.dispatch("orderTransaction/deleteOrderTransaction", {
        type: "order_code",
        id: item.ID,
        orderId: item.OrderID,
        orderCode: item.OrderCodeCN,
        idx: index,
        param: this.ordercode_param
      });
    },
    removeTransCode(index) {
      const item = this.selectedTransCodes[index];
      this.$store.dispatch("orderTransaction/setDetail", {
        data: {
          'RequestAction': 'DEL',
          'TransactionView': 'order_detail',
          PackageType: this.orderType,
        },
        'id': item.ID,
        param: this.trancode_param,
        order_id: item.OrderID
      });
    },
    addOrderCode() {
      if(this.newOrderCode.OrderCodeCN == ''){
        return;
      }
      this.$store.dispatch(
        "ordercn/setDetail",
        {
          data: this.newOrderCode,
          id: this.newOrderCode.ID,
          param: this.ordercode_param
        }
      );
      this.newOrderCode = {
        OrderID: this.orderId,
        OrderCodeCN: "",
        CreatedBy: this.$store.state.authentication.user.username
      };
    },
    addTransCode() {
      if(this.newOrderTrans.TransactionCode == ''){
        return;
      }
      this.newOrderTrans.Username = this.customerName;
      this.newOrderTrans.UID = this.customerID;
      if(this.orderType !== 1) {
          this.newOrderTrans.OrderCodeID = this.orderCodes[this.selectedOrderCode].ID;
      }
      
      this.newOrderTrans.Status = configs.PACKAGE_STATUS_ENUM.DANG_DI_CHUYEN;;
      this.$store.dispatch(
        "orderTransaction/setDetail",
        {
          data: {
            ...this.newOrderTrans,
            TransactionView: 'order_detail'
          },
          id: this.newOrderTrans.ID,
          param: this.trancode_param
        }
      );
      this.newOrderTrans = {
        OrderID: this.orderId,
        Username: this.customerName,
        UID: this.customerID,
        TransactionCode: "",
        TransactionView: 'order_detail',
        PackageType: this.orderType,
        OrderNote: '',
        Weight: 0.0,
        WeightByVolume: 0.0,
        Status: configs.PACKAGE_STATUS_ENUM.DANG_DI_CHUYEN,
        CreatedBy: this.$store.state.authentication.user.username
      };
    },
    editOrderCode(item) {
      var data = {
        ...item,
        ModifiedBy: this.$store.state.authentication.user.username
      };
      delete data.CreatedDate;
      delete data.CreatedBy;
      this.$store.dispatch("ordercn/setDetail", {'data': data, 'id': item.ID, 'param': this.ordercode_param});
    },
    editTransCode: _.debounce(
      function(item) {
        var data = {
          ID: item.ID,
          OrderID: this.orderId,
          Status: item.Status,
          Weight: item.Weight,
          Width: item.Width,
          Height: item.Height,
          Length: item.Length,
          FeeShip: item.FeeShip,
          TransactionCode: item.TransactionCode,
          OrderNote: item.OrderNote,
          IsGuarantee: item.IsGuarantee,
          GuaranteeType: item.GuaranteeType,
          ProductName: item.ProductName,
          ProductAmount: item.ProductAmount,
          ProductNumber: item.ProductNumber,
          NumberOfPack: item.NumberOfPack,
          PackageType: item.PackageType,
          ProductType: item.ProductType,
          PriceType: item.PriceType | 0,
          FeeWeight: item.FeeWeight,
          TransactionView: 'order_detail',
          ModifiedBy: this.$store.state.authentication.user.username
        };
        let guarantee = _.find(this.guarantees, {ID: item.GuaranteeType});
        data.GuaranteeRate = guarantee ? guarantee.PercentFee : 0;
        delete data.CreatedDate;
        delete data.CreatedBy;
        this.$store.dispatch("orderTransaction/setDetail", {'data': data, 'id': item.ID, 'param': this.trancode_param});
      },
      500,
      {
        leading: false,
        trailing: true
      }
    ),
    fetchData: _.debounce(
      function() {
        this.$store.dispatch("orderTransaction/getList", this.trancode_param);
        this.$store.dispatch("ordercn/getList", this.ordercode_param);
      },
      1000,
      {
        leading: true,
        trailing: false
      }
    ),
    printTransaction(id, package_type) {
        request_detail('order_transactions/print', ret => {
            let item = ret.data;
            print_transaction_v2(item);
        }, Vue.http, id, this.$store.state.authentication.token, {'PackageType': package_type});
    },
    checkPackageStatus(status) {
      return status == configs.PACKAGE_STATUS_ENUM.DA_VE_VN || status == configs.PACKAGE_STATUS_ENUM.KH_DA_NHAN;
    }
  },
  computed: {
    ...mapState({
      transCodes: state => _.sortBy(state.orderTransaction.all.data,'ID')
    }),
    ...mapState({
      orderCodes: state =>  _.sortBy(state.ordercn.all.data, "ID")
    }),
    ...mapState({
      configuration: state => state.configuration.selected,
      product_types: state => state.productType.all.data,
    }),
    orderEditRole() {
      return this.$store.state.authentication.role.OrderEditable;
    },
    orderCodeEditable() {
      return (this.orderStatus != configs.ORDER_STATUS_ENUM.huy && this.orderStatus != configs.ORDER_STATUS_ENUM.hoan_thanh && this.orderStatus != configs.ORDER_STATUS_ENUM.da_xuat_kho) || ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin);
    },
    tranCodeEditable() {
      return (this.orderStatus != configs.ORDER_STATUS_ENUM.huy && this.orderStatus != configs.ORDER_STATUS_ENUM.hoan_thanh) || ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin) || ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Payment) == configs.ROLE_TYPE.Payment);
    },
    weightEditable() {
      return ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin) || ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreVN) == configs.ROLE_TYPE.StoreVN) || (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Payment) == configs.ROLE_TYPE.Payment;
    },
    adminRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin || (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Payment) == configs.ROLE_TYPE.Payment;
    },
    purchaseRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Purchase) == configs.ROLE_TYPE.Purchase;
    },
    paymentRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Payment) == configs.ROLE_TYPE.Payment;
    },
    trancode_param() {
      return {
        filter: [
          {
            column: "OrderID",
            value: this.orderId,
            condition: "equal"
          },
          {
            column: "PackageType",
            value: this.orderType,
            condition: "equal"
          }
        ]
      };
    },
    ordercode_param() {
      return {
        filter: [
          {
            column: "OrderID",
            value: this.orderId,
            condition: "equal"
          }
        ]
      };
    }
  },
  mounted() {
    this.$store.dispatch("configuration/getDetail", 1);
    this.fetchData();
    this.$root.$on("REQUEST_REFRESH_DATA", this.fetchData);
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_REFRESH_DATA");
  }
};
</script>

<style scoped>
.trans-status {
  width: 180px;
}
.trans-weight {
  width: 60px;
}
.vertLine {
  border-right: 1px rgba(0, 0, 0, 0.12) !important;
  border-right-style: solid !important;
}
</style>
